// recommended-accessories.js

document.addEventListener("DOMContentLoaded", function () {
  initRecommendedAccessoriesSwiper();
});

document.addEventListener("shopify:section:load", function (event) {
  if (event.target.querySelector(".recommended-accessories")) {
    initRecommendedAccessoriesSwiper();
  }
});

function initRecommendedAccessoriesSwiper() {
  const accessoriesSections = document.querySelectorAll(
    ".recommended-accessories",
  );

  if (!accessoriesSections.length) return;

  accessoriesSections.forEach((section) => {
    const swiperEl = section.querySelector(".accessories-swiper");

    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper(swiperEl, {
      slidesPerView: "auto",

      // 👇 default = mobile
      spaceBetween: 12,

      navigation: {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 40,
        },
      },

      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  });
}
